<div class="card row"
     [class.unavailable]="!canSelect"
     (click)="onClick($event)">
  <span class="circle"
        [class.one]="activity?.priority===1"
        [class.two]="activity?.priority===2"
        [class.three]="activity?.priority===3"
  >{{ activity?.priority }}</span>
    <p class="name" [title]="activity?.name || ''">{{ activity?.name }}</p>
    <app-tooltip *ngIf="showDetails"
                 class="tooltip"
                 type="info"
                 record="{{activity?.description || ('admin.toolMaintenancePlans.activities.details.noDescription' | translate)}}">
    </app-tooltip>
    <app-tooltip *ngIf="showActions"
                 class="tooltip"
                 type="important"
                 record="{{('admin.toolMaintenancePlans.activities.details.revisionInfo') | translate}}"
                 (click)="onRevisionInfoClick()">
        <i class="fa fa-wrench"></i>
    </app-tooltip>
    <div class="tasks" *ngIf="!showDetails">
        <i class="fa fa-check-square-o" *ngIf="finished"></i>
        <p>
            {{ nrTasks }} {{ 'admin.toolMaintenancePlans.activities.tasks' | translate }}
        </p>
    </div>
    <app-assignation-dropdown *ngIf="showDetails && activity?.assignedRole"
                              [selectedItem]="assigned"
                              [readonly]="true">
    </app-assignation-dropdown>

    <app-icon *ngIf="canDelete"
              library="fontawesome"
              variant="fa-trash"
              type="danger"
              [class.ml-auto]="!activity.assignedRole"
              (click)="onDeleteClick($event)">

    </app-icon>

    <app-icon *ngIf="canEdit"
              library="fontawesome"
              variant="fa-pencil"
              [class.ml-auto]="!activity.assignedRole && !canDelete"
              (click)="onEditClick($event)">

    </app-icon>
    <app-timer *ngIf="showActions"
               [standardTime]="activity?.standardTime || 0"
               [elapsedTime]="activity?.elapsedTime || 0"
               [state]="timerState"
               [canPause]="false"
               [canStop]="false"
               (start)="onTimerStart()"
               (pause)="onTimerPause()"
               (stop)="onTimerStop()">
    </app-timer>
    <p class="on-hold-label" *ngIf="onHold()">{{ 'generic.components.timer.onHold' | translate }}</p>
</div>
